import React from 'react'
import { get } from 'lodash'
import { Col, Row } from 'react-bootstrap'
import TitleDescription from 'components/molecules/TitleDescription'

function TabelaOPME({ data, user }) {
  const title = get(data, 'title', '')
  const description = get(data, 'description.value')
  const userProfile = user?.menu === 'secretaria' || user?.menu?.includes('secretaria') ? 'cooperado' : user?.menu ?? ''
  const opmeTableUrlBase = process.env.RAZZLE_OPME_TABLE_BASE_URL;
  const opmeTableToken = process.env.RAZZLE_OPME_TABLE_TOKEN;

  return (
    <div className="my-5">
      <Row>
        <Col>
          <TitleDescription className="mb-2" description={description} title={title} />
        </Col>
      </Row>
      <Row>
        <a
          className="btn btn-outline-primary btn-lg ml-3"
          href={`${opmeTableUrlBase}?token=${opmeTableToken}&usuarioCodigo=${user?.contract}&usuarioPerfil=${userProfile}&usuarioEmail=${user?.email}`}
        >
          Acessar
        </a>
      </Row>
    </div>
  )
}

export default TabelaOPME
